import Cookies from "js-cookie"
import { appServerHost } from "./app-server"

/** Function to convert marketing site locale which is not region specific (en, es etc)
 * into a valid locale for the backend when creating the signup session (en_GB, en_US, es_ES etc).
 *
 * This can be removed if/when the marketing site supports locale variations.
 */
const getSpecificLocaleForRegion = (locale, region) => {
  if (locale === "es") {
    return "es_ES"
  }

  if (locale === "fr") {
    return "fr_FR"
  }

  if (locale === "pt") {
    return "pt_BR"
  }

  // If region is "EU" for example, default the US locale.
  if (locale === "en" && region !== "GB" && region !== "US") {
    return "en_US"
  }

  return `${locale}_${region}`
}

export const fetchUrlParams = location => {
  return new URLSearchParams(location.search)
}

export const createSession = (location, requestBody) => {
  return fetch(`https://api.${appServerHost(location)}/api/v2/signups`, {
    method: "POST",
    body: JSON.stringify(requestBody),
    headers: {
      "Content-type": "application/json; charset=utf-8",
    },
  }).then(response => response.json())
}

export const buildRequestBodyForNormalAuth = (
  emailAddress,
  plan,
  variation,
  locale,
  planFrequency,
) => {
  if (!planFrequency || plan === "free") {
    planFrequency = "MONTHLY"
  }

  const specificLocaleForRegion = getSpecificLocaleForRegion(
    locale,
    Cookies.get("exp_region"),
  )

  return {
    signup: {
      emailAddress,
      plan,
      locale: specificLocaleForRegion,
      planFrequency,
      attribution: buildAttribution(variation, specificLocaleForRegion),
    },
  }
}

export const buildRequestBodyForExternalAuth = (
  oauthType,
  plan,
  variation,
  locale,
  planFrequency,
) => {
  if (!planFrequency || plan === "free") {
    planFrequency = "MONTHLY"
  }

  const specificLocaleForRegion = getSpecificLocaleForRegion(
    locale,
    Cookies.get("exp_region"),
  )

  return {
    signup: {
      oauthType,
      plan,
      locale: specificLocaleForRegion,
      planFrequency,
      attribution: buildAttribution(variation, specificLocaleForRegion),
    },
  }
}

export const buildAttribution = (variation, locale, region = null) => {
  return {
    variation,
    region: region ?? Cookies.get("exp_region"),
    source: Cookies.get("exp_source"),
    referrer: Cookies.get("exp_referrer"),
    friend: Cookies.get("exp_friend"),
    offer: Cookies.get("exp_offer"),
    gclid: Cookies.get("exp_gclid"),
    msclkid: Cookies.get("exp_msclkid"),
    transpond: Cookies.get("mpz"),
    siteLocale: locale,
  }
}

// Builds query parameters for direct registration links that bypass createSession
// These parameters match what would be in the request body of createSession
export const buildQueryParamsForDirectLink = (variation, locale) => {
  const region = Cookies.get("exp_region")
  const specificLocale = getSpecificLocaleForRegion(locale, region)
  const attribution = buildAttribution(variation, specificLocale, region)

  const params = { locale: specificLocale, ...attribution }

  // Filter out null/undefined/empty values
  const filtered = Object.fromEntries(
    Object.entries(params).filter(
      ([_, value]) => value !== null && value !== undefined && value !== "",
    ),
  )

  return new URLSearchParams(filtered).toString()
}
